import React from 'react';
import Autocomplete from 'react-google-autocomplete';

interface AddressAutocompleteProps {
    disabled?: boolean;
    placeholder?: string;
    defaultValue?: string;
    classes?: string;
    error: any;
    onAddressSelected: (address: string, lat: number, lng: number, city: string, state: string, zip: string, timezone: string) => void;
}

const PlacesInput: React.FC<AddressAutocompleteProps> = ({ disabled, classes, error, defaultValue, onAddressSelected }) => {
    const handlePlaceSelected = async (place: any) => {
        console.log(place);
        if (place?.geometry) {
            let address = place?.formatted_address || '';
            const lat = place?.geometry?.location.lat();
            const lng = place?.geometry?.location.lng();
            let city = '';
            let state = '';
            let zip = '';
            let timezone = '';

            place?.address_components?.forEach((component: any) => {
                if (component?.types.includes('locality')) {
                    city = component?.long_name;
                }
                if (component?.types.includes('administrative_area_level_1')) {
                    state = component?.short_name;
                }
                if (component?.types.includes('postal_code')) {
                    zip = component?.long_name;
                    address = address.replace(component?.long_name, '').trim();
                }
            });

            try {
                const timestamp = Math.floor(Date.now() / 1000);
                const timezoneResponse = await fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.REACT_APP_PLACES_API}`);
                const timezoneData = await timezoneResponse.json();
                timezone = timezoneData.timeZoneId;
            } catch (error) {
                console.error('Error fetching timezone:', error);
            }

            onAddressSelected(address, lat, lng, city, state, zip, timezone);
        }
    };

    return (
        <div className="w-full">
            <Autocomplete
            defaultValue={defaultValue}
                apiKey={process.env.REACT_APP_PLACES_API}
                onPlaceSelected={handlePlaceSelected}
                options={{
                    componentRestrictions: { country: 'us' },
                    types: ['address'],
                }}
                className={`w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600  ${classes} ${disabled ? 'placeholder-black' : ''}`}
                disabled={disabled}
                placeholder={defaultValue ?? "Address"}
            />
            {error && <p className="text-red-600 text-sm">{error.message}</p>}
        </div>
    );
};

export default PlacesInput;
